import { useState } from 'react'
import { useAppSelector } from '../../../hooks/redux'
import { Colors } from '../../../constants/Colors'
import style from './CustomAlert.module.css'

interface Props {
    title: string
    onClick: () => void
    disabled: boolean
    
}

const CustomAlertButton = ({
        title,
        onClick,
        disabled
    }: Props
) => {

    const theme = useAppSelector<string>(state => state.theme.theme)

    const [isHover, setIsHover] = useState<boolean>(false)

    const handleMouseEnter = () => {
        setIsHover(true)
    }

    const handleMouseLeave = () => {
        setIsHover(false)
    }

    return (
        <button
            className={style.button}
            style={
                disabled
                    ? {
                        color: Colors[theme ?? 'light'].text,
                        backgroundColor: Colors[theme ?? 'light'].secondBackground
                    }
                    : isHover
                        ? {
                            color: Colors[theme ?? 'light'].activeTint,
                            backgroundColor: Colors[theme ?? 'light'].app
                        }
                        : {
                            color: Colors[theme ?? 'light'].app,
                            backgroundColor: Colors[theme ?? 'light'].thirdBackground
                        }
            }
            onClick={onClick}
            disabled={disabled}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
        >
            {title}
        </button>
    )
}

export default CustomAlertButton